import useSWR from "swr";
import Slider from "react-slick";
import CourseItem from "./CourseItem";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PROXY, fetchData } from "../lib/utils";
import { Button } from "@material-tailwind/react";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CardSkeleton from "./skeleton/CardSkeleton";

const SampleNextArrow = ({ onClick }) => (
  <div
    className="slick-arrow-custom arrow-right"
    onClick={onClick}
    aria-label="Next slide"
  >
    <FaAngleRight />
  </div>
);

const SamplePrevArrow = ({ onClick }) => (
  <div
    className="slick-arrow-custom arrow-left"
    onClick={onClick}
    aria-label="Previous slide"
  >
    <FaAngleLeft />
  </div>
);

const CourseCard = ({ url, title, subTitle, taq, customTitle, customSubtitle }) => {
  const { t, i18n } = useTranslation();

  const fetcher = (url) => fetchData(url, "accessToken");
  const { data, error, isLoading } = useSWR(`${PROXY}/${url}`, fetcher);

  if (error) return <div className="text-red-500">Error: {error.message}</div>;
  if (isLoading) return <CardSkeleton />;

  const orderedData = Array.isArray(data)
    ? [...data].sort(
        (a, b) =>
          new Date(a.createdAt || a.updatedAt) -
          new Date(b.createdAt || b.updatedAt),
      )
    : [];

  const settings = {
    dots: false,
    lazyLoad: true,
    rtl: i18n.language === "en" ? false : true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section
      className="px-4 mx-auto sm:max-w-5xl sm:px-6 lg:max-w-7xl lg:px-8 my-20 overflow-hidden"
      id="courses"
    >
      <div className="flex items-center justify-between">
        <div className="text-sm">
          <h2 className="lg:text-3xl font-semibold mb-3">
            {customTitle || t(title)}
          </h2>
          <p className="lg:text-lg mb-6">{customSubtitle || t(subTitle)}</p>
        </div>

        <Link to={`/courses/filter?q=${taq}`}>
          <Button
            variant="gradient"
            color="white"
            style={{ backgroundColor: "#334780", color: "#fff" }}
            size="sm"
            value="Load More"
          >
            {t("load-more")}
          </Button>
        </Link>
      </div>
      <Slider {...settings}>
        {orderedData.map((course, index) => (
          <div key={course._id}>
            <CourseItem course={course} index={index} />
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default CourseCard;
